module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/ChakraTonicsebk3#_idTextAnchor003"
    }
  }, [_vm._v("note to readers"), _c('span', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-First _idGenParaOverride-1"
  }, [_vm._v("This book is not meant to treat, diagnose, or prescribe. The information contained herein is in no way to be considered as a substitute for your own inner guidance. For any medical condition, physical condition, or symptoms, always consult with a qualified physician or appropriate health care professional. Neither the author nor the publisher accepts any responsibility for your health or how you choose to use the recipes in "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("this")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("book.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-547cc348","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChakraTonicsebk4.vue
// module id = 72
// module chunks = 0